import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent {
  displayMenu: boolean = false;
  positions: ConnectedPosition[] = [
    {
      originX: 'end',     // anchor to the right edge of the parent
      originY: 'bottom',  // anchor to the bottom of the parent
      overlayX: 'end',    // align popover’s right edge
      overlayY: 'top'     // align popover’s top edge
    }
  ];

  user: string = '';
  
  constructor(
    private navService: NavServiceService,
    private apiService: ApiService,
    private router: Router,
    private authService: AuthService
  ){
    

  }

  ngOnInit(){
    this.user = this.authService.getUserName();
  }

  toggleMenu(){
    this.displayMenu = !this.displayMenu;
  }

  goTo(action: string){    
    
    switch(action){
      case 'profile':
      case 'password':
        this.navService.addMode = false;
        let getEmail = localStorage.getItem('Email')
        this.apiService.getbyemailsMY(getEmail).subscribe((data) => 
        {
          let UserAllData = data.data
          this.navService.data = UserAllData;

          this.displayMenu = false;
          return this.router.navigate(['/management/security-level/user-manage'],{replaceUrl: true,});
        },
        (error) => {

        });
        break;
      case 'logout':
        this.navService.LogOut();
        this.displayMenu = false;
        break;
    }

  }

}
